import Footer from './Footer/index.js'
import FooterCompact from './FooterCompact/index.js'
import HeaderCompactWithChildren from './HeaderCompact/index.js'
import HeaderWithChildren from './Header/index.js'

export default {
  HeaderCompact: HeaderCompactWithChildren,
  Header: HeaderWithChildren,
  FooterCompact: FooterCompact,
  Footer: Footer,
}
